<template lang="pug">
  .expired-coupon-modal-content
    img.expired-coupon-modal-content__img(src="~@/assets/cry-girl-animated.svg")
    p.expired-coupon-modal-content__description O cupom utilizado anteriormente expirou
    cp-button(label="Cotar novamente" theme="purple-filled" @click="onQuoteAgain")
</template>
<script>
import cpButton from '@/components/ui/Button'
export default {
  components: {
    cpButton
  },
  methods: {
    onQuoteAgain () {
      this.$emit('toggle')
    }
  }
}
</script>
<style lang="scss">
@import "~@/style/ui/variables";
.expired-coupon-modal-content {
  padding: 0 24px;
  font-family: $oscine-font-family;
  font-size: 32px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  &__img {
    margin-bottom: 39px;
    margin-top: 67px;
    @media screen and (min-width: 768px) {
      margin-top: 78px;
    }
    @media screen and (min-width: 1366px) {
      margin-top: 114px;
    }
  }

  &__description {
    max-width: 430px;
    margin-bottom: 32px;
  }
}
</style>
